// Lib
import { isEmpty } from 'lodash/fp';

// Utils
import { decodeParams, getQueryString } from '../utils/urlUtil';

// Constants
import { APP_QUERY_PARAMS } from '../utils/urlConstants';

/**
 * Retrieves a permission ID from a Milanote URL, if one exists.
 * E.g. "http://localhost:3000/1IkUMX0EQoEb00/research?p=82wh0ql2onI" will return "82wh0ql2onI".
 */
export const getPermissionIdFromUrlString = (url) => {
    if (!url) return null;

    const queryString = getQueryString(url);

    if (isEmpty(queryString)) return null;

    const params = decodeParams(queryString);
    return params[APP_QUERY_PARAMS.PERMISSION];
};

export const getBoardUrl = ({ boardId, permissionId }) =>
    permissionId ? `/${boardId}?${APP_QUERY_PARAMS.PERMISSION}=${permissionId}` : `/${boardId}`;
